module.exports = __webpack_public_path__ + "static/fonts/TitilliumWeb-Light.1615bb1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TitilliumWeb/TitilliumWeb-Light.ttf
// module id = JX6S
// module chunks = 0